import config from "../config/app.conf.json";

export default data => ({
  url: config.api.newPassword,
  method: "POST",
  data: data,
  headers: {
    "Content-Type": "application/json"
  }
});
